<template>
  <draggable
    :list="options"
    class="list-group"
    ghost-class="ghost"
    @start="dragging = true"
    @end="dragging = false"
  >
    <v-layout
      align-center
      class="mb-3 ml-1 text-xs-left"
      :key="i"
      v-for="(option, i) in options"
    >
      <v-icon class="mr-2" style="cursor: pointer"> drag_handle </v-icon>

      <template>
        <v-checkbox
          class="mt-0"
          hide-details
          :input-value="!excluded.includes(option.id)"
          @change="toggle($event, option)"
        >
          <template slot="label">
            <slot name="label" :option="option"> </slot>
          </template>
        </v-checkbox>
      </template>
    </v-layout>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  name: 'MultipleOptionsInput',
  components: {
    draggable,
  },
  props: {
    value: {
      type: Array,
    },
    excluded: {
      type: Array,
    },
  },
  data() {
    return {
      options: [],
      dragging: false,
      editOption: null,
      textToEdit: null,
    };
  },
  watch: {
    value(newVal) {
      this.options = newVal;
    },
    options: {
      handler(newList) {
        this.$emit('input', newList);
      },
    },
  },
  methods: {
    toggle(value, option) {
      if (value) {
        this.$emit(
          'update:excluded',
          this.excluded.filter(id => option.id !== id),
        );
      } else {
        this.$emit('update:excluded', this.excluded.concat([option.id]));
      }
    },
  },
  created() {
    this.options = this.value;
  },
};
</script>

<style scoped></style>
